import React from "react";
import { Card, Col } from "react-bootstrap";
import "./card.css";
const card = (props) => {
  return (
    <Col md={3} style={{ paddingTop: "3rem" }}>
      <Card className="shadow p-3 mb-5 bg-white rounded" bg="Dark">
        <Card.Img variant="top" src={props.photo} />
        <Card.Header>
          <Card.Title>
            <a href={props.link}>{props.name}</a>
          </Card.Title>
          <Card.Subtitle>{props.cllg}</Card.Subtitle>
        </Card.Header>
        <Card.Body>
          <Card.Subtitle>{props.pos}</Card.Subtitle>
        </Card.Body>
        <Card.Footer>Number of Articles : {props.work}</Card.Footer>
      </Card>
    </Col>
  );
};

export default card;
